<template>
  <v-container class="records-content" fluid>
    <div class="header">
      <h2>Configurações</h2>
    </div>
    <v-row dense class="pb-15 px-5">
      <v-col v-if="user_logged" cols="12" class="mb-2">
        <div style="border: 5px solid #f5f5f5; height: 80px; overflow: hidden; border-radius: 6px;">
          <img :src="getOrganizationParameter('REPORT_LOGO')" style="height: 100%; margin: 0 auto; display: block; padding: 8px;">
        </div>
      </v-col>
      <v-col cols="12" v-if="user_multiple_organizations.selected">
        <v-select
          v-model="user_multiple_organizations.selected"
          :items="user_multiple_organizations.list"
          @change="changeUserOrganization()"
          item-text="name"
          item-value="id_external"
          label="Selecionar empresa"
          class="mb-3 mt-1"
          outlined
          hide-details
        ></v-select>
      </v-col>
      <v-col v-for="item in items" :key="item.title" :cols="item.flex">
        <v-card @click="openModal(item)">
          <v-img
            :src="require('@/assets/records/'+item.src)"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)"
            height="200px"
          >
            <v-card-title v-text="item.title"></v-card-title>
          </v-img>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card @click="openModal({ref: 'Parameters'})">
          <v-img
            :src="require('@/assets/records/painel-ferramenta.jpg')"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)"
            height="200px"
          >
            <v-card-title>Parâmetros</v-card-title>
          </v-img>
        </v-card>
      </v-col>
      <v-col v-if="false" cols="6">
        <v-card @click="openOnboardingModal()">
          <v-img
            :src="require('@/assets/records/cadastro-pecas.jpg')"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)"
            height="200px"
            style="background-position-x: 80%;"
          >
            <v-card-title>Configuração</v-card-title>
          </v-img>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card @click="openSignatureModal()">
          <v-img
            :src="require('@/assets/records/cadastro-checklist.jpg')"
            class="white--text align-end"
            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.8)"
            height="200px"
            style="background-position-x: 80%;"
          >
            <v-card-title>Meu plano</v-card-title>
          </v-img>
        </v-card>
      </v-col>
      <v-col cols="12">
        <img
          :src="require('@/assets/banner-checktalkie.png')"
          @click="openCheckTalkieWhatsapp()"
          style="width: 100%; border-radius: 4px; box-shadow: rgba(0, 0, 0, 0.2) 0px 3px 1px -2px, rgba(0, 0, 0, 0.14) 0px 2px 2px 0px, rgba(0, 0, 0, 0.12) 0px 1px 5px 0px; cursor: pointer;"
        >
      </v-col>
      <v-col cols="12 pb-10">
        <div class="footer-checkmotors">
          <div @click="openSupportWhatsapp()" style="color: #48c295; margin-bottom: 5px;"><v-icon color="#48c295" size="20px" style="margin-top: -2px;">mdi-whatsapp</v-icon> Fale conosco</div>
          {{ new Date().getFullYear() }} © <b>CheckMotors v3.7.41</b> <br>
          <a @click="openTerms()" style="color: rgba(0, 0, 0, 0.6) !important;">Termos de uso e política de privacidade</a>
        </div>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog.open"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <component v-if="dialog.open" :is="dialog.ref" @return="closeModal()"></component>
    </v-dialog>
  </v-container>
</template>

<script>

import Clients from '@/components/Records/Clients';
import Dashboards from '@/components/Records/Dashboards';
import Website from '@/components/Records/Website';
import Parameters from '@/components/Records/Parameters';

export default {
  name: 'Cadastros',
  components: {
    Website,
    Clients,
    Dashboards,
    Parameters,
  },
  data: () => ({
    user_logged: null,
    user_multiple_organizations: {
      user_id: null,
      selected: null,
      list: []
    },
    dialog: {
      open: false,
      ref: null,
    },
    items: [
      // {
      //   ref: 'Dashboards',
      //   title: 'Indicadores',
      //   src: 'cadastro-checklist.jpg',
      //   flex: 6,
      // },
      {
        ref: 'Clients',
        title: 'Clientes',
        src: 'clientes.jpeg',
        flex: 12,
      },
      // {
      //   ref: 'OnBoardingDialog',
      //   title: 'Configurações',
      //   src: 'cadastro-pecas.jpg',
      //   flex: 6,
      // },
      // {
      //   ref: 'Services',
      //   title: 'Serviços',
      //   src: 'cadastro-servicos.jpg',
      //   flex: 6,
      // },
      // {
      //   ref: 'Products',
      //   title: 'Peças',
      //   src: 'cadastro-pecas.jpg',
      //   flex: 6,
      // },
      // {
      //   ref: 'checklists',
      //   title: "Checklist's",
      //   src: 'cadastro-checklist.jpg',
      //   flex: 12,
      // },
      // {
      //   ref: 'Users',
      //   title: 'Usuários do sistema',
      //   src: 'cadastro-usuarios-oficina.jpg',
      //   flex: 12,
      // },
    ],
  }),
  mounted() {
    this.user_logged = this.$store.getters['Auth/user'];
    if (this.user_logged.user_multiple_organizations && this.user_logged.user_multiple_organizations.length > 1) {
      this.user_logged.user_multiple_organizations.forEach((i) => {
        this.user_multiple_organizations.list.push(i.organization);
      });
      this.user_multiple_organizations.user_id = this.user_logged.id;
      this.user_multiple_organizations.selected = this.user_logged.organization.id_external;
    }
    setTimeout(() => {
      window.scrollTo(0,0);
    }, 200);
  },
  methods: {
    openTerms() {
      this.$store.dispatch('Auth/openTerms');
    },
    getOrganizationParameter(code) {
      const param = this.user_logged?.organization?.organization_parameters?.find((parameter) => parameter.code === code);
      return param?.value ?? null;
    },
    openModal(item) {
      this.dialog.open = true;
      this.dialog.ref = item.ref;
    },
    openSignatureModal() {
      this.$emit('open-signature-modal');
    },
    openOnboardingModal() {
      this.$emit('open-onboarding-modal');
    },
    closeModal() {
      this.dialog.open = false;
      this.dialog.ref = null;
    },
    changeUserOrganization() {
      this.$http.post('/user/change/organization', {
        organization: this.user_multiple_organizations.selected
      }).then(() => {
        setTimeout(() => {
          window.location.reload();
        }, 500);
      });
    },
    openSupportWhatsapp() {
      window.open(`whatsapp://send?phone=5565992774481`)
    },
    openCheckTalkieWhatsapp() {
      window.open(`whatsapp://send?phone=5519958713393&text=${encodeURIComponent('Quero resgatar o mês grátis do CheckTalkie')}`)
    },
  }
};
</script>

<style lang="scss">
.records-content {
  padding: 0px;
  padding-bottom: 70px;

  .header {
    padding: 20px 20px;
    background-color: #EEEEEE;
    margin-bottom: 20px;
  }
}

.v-dialog {
  background-color: #fff;
}

.modal-parametros {

  .header {
    padding: 20px 20px;
    background-color: #EEEEEE;
    position: fixed;
    width: 100%;
    z-index: 999;

    h2 {
      padding-top: 7px;
    }

    .add {
      float: right;
      background-color: #48B38B;
      border-radius: 50%;
      margin-right: 10px;
      padding: 10px;
    }

    .close {
      float: right;
      background-color: #c7c7c7;
      border-radius: 50%;
      padding: 10px;
    }
  }

  .sub-header {
    background-color: #F5F5F5;
    overflow: hidden;
    padding: 10px;

    .back-btn {
      float: left;
      padding-left: 5px;
      padding-right: 12px;
      margin-right: 12px;
      border-right: 1px solid rgba(0, 0, 0, 0.14);
    }

    .content {
      font-size: 18px;
      float: left;
    }
  }

  .body {
    padding: 20px;
    padding-top: 93px;

    .total-items {
      padding: 10px 0px;
      font-weight: 600;
    }

    .label-separator {
      font-size: 14px;
      margin: 10px 0px;
      font-weight: 600;
    }

    .context-container {
      padding: 10px;
      border-radius: 10px;
      background-color: #F5F5F5;
    }

    .box {

      .add {
        text-align: center;
        border: 1px dashed #009688;
        color: #009688;
        font-weight: 600;
        border-radius: 4px;
        padding: 10px 20px;
        margin-bottom: 16px;
      }
    }
  }

}

.footer-checkmotors {
  color: rgba(0,0,0,.6)!important;
  font-size: 12px;
  text-align: center;
  margin-top: 14px;
}

</style>
